const standardCase = (text = "") => {
  const words = text.trim().split(" ");
  words.forEach((el, i) => {
    words[i] = el.slice(0, 1).toUpperCase() + el.slice(1).toLowerCase();
  });
  return words.join(" ");
};

export { standardCase };
